// extracted by mini-css-extract-plugin
module.exports = {"whslyen":"whslyen","fadeFromTransparent":"fadeFromTransparent"};